(() => {
    'use strict';

    const fontSizeType = {
        min: 'min',
        normal: 'normal',
        max: 'max'
    };

    let actualFontSizeType = fontSizeType.normal;

    const setFontSize = (type, setLocalStorage) => {
        const size = fontSizeType[type];

        $('html').attr('data-font-size', size);

        if (setLocalStorage)
            localStorage.setItem('font-size', type);
    }

    $(() => {
        // Handle font size
        if (localStorage.getItem('font-size')) {
            actualFontSizeType = localStorage.getItem('font-size');
        }
        setFontSize(actualFontSizeType, false);

        // events
        $('.font-trigger').on('click', function (e) {
            if (actualFontSizeType === fontSizeType.normal)
                actualFontSizeType = fontSizeType.max;
            else if (actualFontSizeType === fontSizeType.max)
                actualFontSizeType = fontSizeType.min;
            else if (actualFontSizeType === fontSizeType.min)
                actualFontSizeType = fontSizeType.normal;

            setFontSize(actualFontSizeType, true);
            e.preventDefault();
            return false;
        });

        // Handle contrast

	    if (getCookie('contrast') && getCookie('contrast') === 'on') {
		    $('.contrast-trigger').addClass('active');
		    $('body').addClass('contrast');
	    }

        // events
        $('.contrast-trigger').on('click', function (e) {
	        if (getCookie('contrast') && getCookie('contrast') === 'on') {
				setCookie('contrast', 'off');
                $('.contrast-trigger').removeClass('active');
            } else {
		        setCookie('contrast', 'on');
                $('.contrast-trigger').addClass('active');
            }
            $('body').toggleClass('contrast');
            e.preventDefault();
            return false;
        });
    })

})();
